// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosPromise } from 'axios';

import { authGet, authPost, authDelete, parseSnakeCase } from './util';

export async function getCart() {
  return authGet('/ec/cart', {
    transformResponse: (result: any) => {
      return result.map((course: any) => {
        const parsed = {
          id: course.online_course_id,
          names: course.names,
          thumbUrl: course.image_url,
          price: course.price,
          favourite: false
        }
        return parsed;
      })
    }
  });
}

export async function addOnlineCourseToCart(id: number): Promise<any> {
  console.log(id);
  return await authPost('/ec/cart/onlineCourses', { onlineCourseId: id });
}

export const removeOnlineCourseFromCart = (id: number): AxiosPromise => {
  return authDelete(`/ec/cart/onlineCourses/${id}`);
}

export async function checkCoupon(couponCode: string): Promise<any> {
  return await authPost('/ec/cart/checkCoupon', { coupon: couponCode }, {
    transformResponse: (result: any) => parseSnakeCase(result)
  });
}

export async function cartCheckout(body: any): Promise<any> {
  return authPost('/ec/checkout/cart', { lang: 'cht', ...body })
    .then((data: any) => {
      console.log('checkout', data.data.body);
      return data.data
    })
    .catch((error) => {
      console.log('checkout', { error });
    });
}

export const getOrders = (page: number, limit: number, state: string): AxiosPromise => {
  return authGet(`/ec/checkout/paymentInfo?limit=${limit}&page=${page}&state=${state}`, {
    transformResponse: ({ count, list, totalPage }: any) => {
      const parsed = list.map(({ transaction_id: id, ...data }: any) => ({
        id,
        ...data,
      }));
      return {
        count,
        limit: limit,
        page: page,
        totalPage,
        list: parsed
      };
    }
  });
};

export const cancelOrder = (orderNo: string): AxiosPromise => {
  return authDelete('/ec/checkout/paymentInfo?order_no=' + orderNo);
}
